var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-12"},[_vm._v("welcome page")]),_vm._v(" token:"+_vm._s(_vm.$store.state.auth.my_web_token)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }